import React from "react";

const PostSkeleton = () => {
  return (
    <div className="feed-post-card skeleton">
      {/* Header */}
      <div className="post-header-container d-flex align-items-center">
        <div className="skeleton-avatar"></div>
        <div className="skeleton-header-text">
          <div className="skeleton-line short"></div>
          <div className="skeleton-line xsmall"></div>
        </div>
      </div>

      {/* Text */}
      <div className="skeleton-line"></div>
      <div className="skeleton-line"></div>

      {/* Image */}
      <div className="skeleton-image"></div>

      {/* Footer */}
      <div className="skeleton-footer">
        <div className="skeleton-icon"></div>
        <div className="skeleton-icon"></div>
        <div className="skeleton-icon"></div>
      </div>
    </div>
  );
};

export default PostSkeleton;